/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ code: NonNullable<unknown> }} Voice_Error_UnexpectedInputs */



/**
* | output |
* | --- |
* | "Voice mode ended unexpectedly ({code}). Please start it again." |
*
* @param {Voice_Error_UnexpectedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const voice_error_unexpected = /** @type {((inputs: Voice_Error_UnexpectedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Voice_Error_UnexpectedInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Der Sprachmodus wurde unerwartet beendet (${i?.code}). Bitte starten Sie ihn erneut.`)
	return /** @type {LocalizedString} */ (`Voice mode ended unexpectedly (${i?.code}). Please start it again.`)
});